import React from 'react';
import { useLazyGetInspectionSampleSizeQuery } from '../api';

type Props = {
  quantity: number;
  inspectionLevel: string;
  inspectionAqlCritical?: string;
  inspectionAqlMajor?: string;
  inspectionAqlMinor?: string;
};

const useGetSampleSize = (props: Props, skip = false) => {
  const [fetch, result] = useLazyGetInspectionSampleSizeQuery();

  React.useEffect(() => {
    if (!skip) {
      fetch({
        qty: props?.quantity,
        inspectionLevel: props.inspectionLevel,
        inspectionAqlCritical: props.inspectionAqlCritical,
        inspectionAqlMajor: props.inspectionAqlMajor,
        inspectionAqlMinor: props.inspectionAqlMinor
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props, JSON.stringify(skip)]);

  return result;
};

export default useGetSampleSize;
